module.exports = __webpack_public_path__ + "img/bank-slip.b88171e3.jpg";